import { useMemo, useState } from "react";
import { useSite } from "../context/SiteContext";
import { Seo } from "../components/site/Seo";
import { PageHeader } from "../components/site/PageHeader";
import { GalleryGrid } from "../components/site/GalleryGrid";
import { InstagramSection } from "../components/site/InstagramSection";
import { CampaignBanner } from "../components/site/CampaignBanner";

export default function GalleryPage() {
  const { gallery } = useSite();
  const [cat, setCat] = useState("Tümü");
  const cats = useMemo(() => ["Tümü", ...new Set(gallery.map((g) => g.category))], [gallery]);
  const items = cat === "Tümü" ? gallery : gallery.filter((g) => g.category === cat);
  const crumbs = [{ to: "/", label: "Ana Sayfa" }, { to: "/galeri", label: "Galeri" }];
  return (
    <>
      <Seo
        title="Lunessa Spa Masaj Galeri | Sivas"
        description="Lunessa Spa Masaj galeri: Sivas Merkez'deki masaj odalarımız, jakuzi alanımız ve salonumuzdan kareler. Huzurlu atmosferimizi yakından görün."
        path="/galeri"
        image="/images/lunessa-sivas-masaj-odasi-1.webp"
        breadcrumbs={crumbs}
      />
      <PageHeader eyebrow="Galeri" h1="Lunessa Spa Masaj Galeri" intro="Sivas Merkez’deki salonumuzdan, masaj odalarımızdan ve jakuzi alanımızdan kareler." image="/images/lunessa-sivas-masaj-odasi-1.webp" imageAlt="lunessa-sivas-masaj-salonu-galeri" crumbs={crumbs} />
      <section className="container-lux py-16 lg:py-24">
        <p className="mb-8 max-w-3xl text-base leading-relaxed text-ink/70">
          Lunessa’da her alan, misafirlerimizin kendini rahat ve güvende hissetmesi için özenle düzenlendi. Çift masalı masaj odalarımız, masaj odalarıyla bütünleşik jakuzi alanımız ve sakin karşılama bölümümüz, Sivas’ta huzurlu bir mola için sizi bekliyor.
        </p>
        <div className="mb-10 flex flex-wrap gap-2" role="tablist" data-testid="gallery-filters">
          {cats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              data-testid={`gallery-filter-${c}`}
              className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${cat === c ? "border-emerald-900 bg-emerald-900 text-cream" : "border-gold/30 text-emerald-900 hover:border-gold"}`}
            >
              {c}
            </button>
          ))}
        </div>
        <GalleryGrid items={items} />
      </section>
      <CampaignBanner />
      <InstagramSection />
    </>
  );
}
